<template>
  <Navbar />
  <TrainingAnlegenModalComponent ref="trainingseinheitAnlegenModal" />
  <RadioModalComponent ref="radioModal"></RadioModalComponent>
  <Notifications position="top center" />
  <div class="container">
    <router-view />
  </div>
</template>

<script>
import Navbar from "./components/Shared/NavbarComponent.vue";
import { Notifications } from "@kyvg/vue3-notification";
import TrainingAnlegenModalComponent from "@/components/Training/TrainingAnlegenModalComponent.vue";
import RadioModalComponent from "@/components/Shared/RadioModalComponent.vue";

export default {
  components: {
    Notifications,
    Navbar,
    TrainingAnlegenModalComponent,
    RadioModalComponent,
  },
};
</script>

<style>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
}

.container {
  margin-top: calc(1.5rem + 56px) !important;
}
</style>
